export interface ICountryLength {
  country: string;
  phLength: number;
}

export const countryNumberLength = [
  {
    country: "China",
    phLength: 13
  },
  {
    country: "Mozambique",
    phLength: 12
  },
  {
    country: "Brazil",
    phLength: 11
  },
  {
    country: "India",
    phLength: 10
  },
  {
    country: "United States",
    phLength: 10
  },
  {
    country: "Pakistan",
    phLength: 10
  },
  {
    country: "Bangladesh",
    phLength: 10
  },
  {
    country: "Russia",
    phLength: 10
  },
  {
    country: "Mexico",
    phLength: 10
  },
  {
    country: "Japan",
    phLength: 10
  },
  {
    country: "Philippines",
    phLength: 10
  },
  {
    country: "Egypt",
    phLength: 10
  },
  {
    country: "Iran",
    phLength: 10
  },
  {
    country: "Turkey",
    phLength: 10
  },
  {
    country: "Germany",
    phLength: 10
  },
  {
    country: "United Kingdom",
    phLength: 10
  },
  {
    country: "Italy",
    phLength: 10
  },
  {
    country: "Kenya",
    phLength: 10
  },
  {
    country: "Colombia",
    phLength: 10
  },
  {
    country: "South Korea",
    phLength: 10
  },
  {
    country: "Canada",
    phLength: 10
  },
  {
    country: "Nepal",
    phLength: 10
  },
  {
    country: "Romania",
    phLength: 10
  },
  {
    country: "Kazakhstan",
    phLength: 10
  },
  {
    country: "Dominican Republic",
    phLength: 10
  },
  {
    country: "Greece",
    phLength: 10
  },
  {
    country: "Austria",
    phLength: 10
  },
  {
    country: "Libya",
    phLength: 10
  },
  {
    country: "Puerto Rico",
    phLength: 10
  },
  {
    country: "Jamaica",
    phLength: 10
  },
  {
    country: "Trinidad and Tobago",
    phLength: 10
  },
  {
    country: "Bahamas",
    phLength: 10
  },
  {
    country: "Barbados",
    phLength: 10
  },
  {
    country: "Saint Lucia",
    phLength: 10
  },
  {
    country: "Guam",
    phLength: 10
  },
  {
    country: "Grenada",
    phLength: 10
  },
  {
    country: "Saint Vincent and the Grenadines",
    phLength: 10
  },
  {
    country: "United States Virgin Islands",
    phLength: 10
  },
  {
    country: "Antigua and Barbuda",
    phLength: 10
  },
  {
    country: "Isle of Man",
    phLength: 10
  },
  {
    country: "Dominica",
    phLength: 10
  },
  {
    country: "Cayman Islands",
    phLength: 10
  },
  {
    country: "Bermuda",
    phLength: 10
  },
  {
    country: "Guernsey",
    phLength: 10
  },
  {
    country: "Northern Mariana Islands",
    phLength: 10
  },
  {
    country: "Saint Kitts and Nevis",
    phLength: 10
  },
  {
    country: "Turks and Caicos Islands",
    phLength: 10
  },
  {
    country: "American Samoa",
    phLength: 10
  },
  {
    country: "Sint Maarten",
    phLength: 10
  },
  {
    country: "British Virgin Islands",
    phLength: 10
  },
  {
    country: "Anguilla",
    phLength: 10
  },
  {
    country: "Montserrat",
    phLength: 10
  },
  {
    country: "Vatican City",
    phLength: 10
  },
  {
    country: "Indonesia",
    phLength: 9
  },
  {
    country: "Vietnam",
    phLength: 9
  },
  {
    country: "Thailand",
    phLength: 9
  },
  {
    country: "South Africa",
    phLength: 9
  },
  {
    country: "Spain",
    phLength: 9
  },
  {
    country: "Algeria",
    phLength: 9
  },
  {
    country: "Afghanistan",
    phLength: 9
  },
  {
    country: "Poland",
    phLength: 9
  },
  {
    country: "Ukraine",
    phLength: 9
  },
  {
    country: "Saudi Arabia",
    phLength: 9
  },
  {
    country: "Peru",
    phLength: 9
  },
  {
    country: "Yemen",
    phLength: 9
  },
  {
    country: "Ghana",
    phLength: 9
  },
  {
    country: "Cameroon",
    phLength: 9
  },
  {
    country: "Australia",
    phLength: 9
  },
  {
    country: "Taiwan",
    phLength: 9
  },
  {
    country: "Syria",
    phLength: 9
  },
  {
    country: "Zambia",
    phLength: 9
  },
  {
    country: "Chile",
    phLength: 9
  },
  {
    country: "Ecuador",
    phLength: 9
  },
  {
    country: "Netherlands",
    phLength: 9
  },
  {
    country: "Cambodia",
    phLength: 9
  },
  {
    country: "Zimbabwe",
    phLength: 9
  },
  {
    country: "Benin",
    phLength: 9
  },
  {
    country: "Belgium",
    phLength: 9
  },
  {
    country: "Jordan",
    phLength: 9
  },
  {
    country: "Czech Republic",
    phLength: 9
  },
  {
    country: "Azerbaijan",
    phLength: 9
  },
  {
    country: "Portugal",
    phLength: 9
  },
  {
    country: "Hungary",
    phLength: 9
  },
  {
    country: "Belarus",
    phLength: 9
  },
  {
    country: "United Arab Emirates",
    phLength: 9
  },
  {
    country: "Israel",
    phLength: 9
  },
  {
    country: "Switzerland",
    phLength: 9
  },
  {
    country: "Paraguay",
    phLength: 9
  },
  {
    country: "Slovakia",
    phLength: 9
  },
  {
    country: "New Zealand",
    phLength: 9
  },
  {
    country: "Ireland",
    phLength: 9
  },
  {
    country: "Croatia",
    phLength: 9
  },
  {
    country: "Georgia",
    phLength: 9
  },
  {
    country: "Luxembourg",
    phLength: 9
  },
  {
    country: "Guadeloupe",
    phLength: 9
  },
  {
    country: "Martinique",
    phLength: 9
  },
  {
    country: "French Guiana",
    phLength: 9
  },
  {
    country: "Nigeria",
    phLength: 8
  },
  {
    country: "Myanmar",
    phLength: 8
  },
  {
    country: "Niger",
    phLength: 8
  },
  {
    country: "Burkina Faso",
    phLength: 8
  },
  {
    country: "Mali",
    phLength: 8
  },
  {
    country: "Guatemala",
    phLength: 8
  },
  {
    country: "Chad",
    phLength: 8
  },
  {
    country: "Somalia",
    phLength: 8
  },
  {
    country: "Tunisia",
    phLength: 8
  },
  {
    country: "Honduras",
    phLength: 8
  },
  {
    country: "Togo",
    phLength: 8
  },
  {
    country: "Hong Kong",
    phLength: 8
  },
  {
    country: "Serbia",
    phLength: 8
  },
  {
    country: "Nicaragua",
    phLength: 8
  },
  {
    country: "El Salvador",
    phLength: 8
  },
  {
    country: "Singapore",
    phLength: 8
  },
  {
    country: "Denmark",
    phLength: 8
  },
  {
    country: "Norway",
    phLength: 8
  },
  {
    country: "Costa Rica",
    phLength: 8
  },
  {
    country: "Oman",
    phLength: 8
  },
  {
    country: "Panama",
    phLength: 8
  },
  {
    country: "Kuwait",
    phLength: 8
  },
  {
    country: "Moldova",
    phLength: 8
  },
  {
    country: "Bosnia and Herzegovina",
    phLength: 8
  },
  {
    country: "Armenia",
    phLength: 8
  },
  {
    country: "Lithuania",
    phLength: 8
  },
  {
    country: "Qatar",
    phLength: 8
  },
  {
    country: "North Macedonia",
    phLength: 8
  },
  {
    country: "Latvia",
    phLength: 8
  },
  {
    country: "Bahrain",
    phLength: 8
  },
  {
    country: "Estonia",
    phLength: 8
  },
  {
    country: "Mauritius",
    phLength: 8
  },
  {
    country: "Cyprus",
    phLength: 8
  },
  {
    country: "Montenegro",
    phLength: 8
  },
  {
    country: "Malta",
    phLength: 8
  },
  {
    country: "Kiribati",
    phLength: 8
  },
  {
    country: "Malaysia",
    phLength: [7,9]
  },
  {
    country: "Venezuela",
    phLength: 7
  },
  {
    country: "Sri Lanka",
    phLength: 7
  },
  {
    country: "Sweden",
    phLength: 7
  },
  {
    country: "Lebanon",
    phLength: 7
  },
  {
    country: "Liberia",
    phLength: 7
  },
  {
    country: "Gabon",
    phLength: 7
  },
  {
    country: "Solomon Islands",
    phLength: 7
  },
  {
    country: "Maldives",
    phLength: 7
  },
  {
    country: "Belize",
    phLength: 7
  },
  {
    country: "Micronesia",
    phLength: 7
  },
  {
    country: "Aruba",
    phLength: 7
  },
  {
    country: "Marshall Islands",
    phLength: 7
  },
  {
    country: "Palau",
    phLength: 7
  },
  {
    country: "Tanzania",
    phLength: 6
  },
  {
    country: "French Polynesia",
    phLength: 6
  },
  {
    country: "New Caledonia",
    phLength: 6
  },
  {
    country: "Greenland",
    phLength: 6
  },
  {
    country: "Samoa",
    phLength: 5
  },
  {
    country: "Faroe Islands",
    phLength: 5
  },
  {
    country: "Cook Islands",
    phLength: 5
  },
  {
    country: "Niue",
    phLength: 4
  }
];


export const countryWithCodes = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'AndorrA', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D\'Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People\'S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' }
]
